import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseBase } from '../models/response-base';
import { Observable } from 'rxjs';
import { Unidade } from '../models/unidade';
import { UnidadeCadastro } from '../models/unidade-cadastro';

@Injectable({
  providedIn: 'root'
})
export class UnidadeService {

  API: string = environment.API + 'Portal/unidades';

  constructor(private http: HttpClient) { }

  add(unidade: UnidadeCadastro, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Unidade>> {
    return this.http.post<ResponseBase<Unidade>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, unidade);
  }

  getAll(cedenteGuid: string): Observable<ResponseBase<Unidade[]>> {
    return this.http.get<ResponseBase<Unidade[]>>(`${this.API}/cedentes/${cedenteGuid}`);
  }

  delete(unidadeId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Unidade>> {
    return this.http.delete<ResponseBase<Unidade>>(`${this.API}/${unidadeId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
  }

  update(unidadeId: number, unidade: UnidadeCadastro, cedenteGuid: string, gestorGuid: string):
  Observable<ResponseBase<Unidade>> {
    return this.http.put<ResponseBase<Unidade>>(`${this.API}/${unidadeId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, unidade);
  }

  getById(unidadeId: number, cedenteGuid: string): Observable<ResponseBase<Unidade>> {
    return this.http.get<ResponseBase<Unidade>>(`${this.API}/${unidadeId}/cedentes/${cedenteGuid}`);
  }
}
